const normalizeName = (name) => String(name || '').trim().toLowerCase()
 
export const findMedicationInteractions = (selectedMedication, medications = [], masterMedications = []) => {
  const getName = (medication) => typeof medication === 'string' ? medication : medication?.name
  const getRules = (medication) => {
    const master = masterMedications.find((item) => normalizeName(item.name) === normalizeName(getName(medication)))
    const rules = master?.drugIntervention ?? medication?.drugIntervention ?? medication?.intervations
    return Array.isArray(rules) ? rules : []
  }
  const selectedName = normalizeName(getName(selectedMedication))
  if (!selectedName) return []

  const interactions = new Map()
  medications.forEach((medication) => {
    const otherName = normalizeName(getName(medication))
    if (!otherName || otherName === selectedName) return

    const rules = [
      ...getRules(medication).filter((rule) => normalizeName(rule.medicationName) === selectedName),
      ...getRules(selectedMedication).filter((rule) => normalizeName(rule.medicationName) === otherName),
    ]
    rules.forEach((rule) => {
      const key = JSON.stringify([otherName, String(rule.note || '').trim()])
      interactions.set(key, { ...rule, nameOfMedicine: getName(medication) })
    })
  })
  return [...interactions.values()]
}
